/**
 * Routes du module Ventes (Lot G) — référencées en <Link>. Certaines cibles
 * (Assistant B2B, Fiche facture, caveau, paramètres) sont câblées par d'autres
 * écrans/agents ; on ne connaît d'elles que leur chemin (comme ROUTES_CONFORMITE
 * du Lot F). Le câblage effectif dans App.tsx est fait par l'orchestrateur.
 */

export const ROUTES_VENTES = {
  hub: "/ventes",
  catalogue: "/ventes/catalogue",
  clients: "/ventes/clients",
  nouveauClient: "/ventes/clients/nouveau",
  ficheClient: (id: string) => `/ventes/clients/${id}`,
  /** Assistant vente B2B (autre agent). */
  nouveauDocument: "/ventes/documents/nouveau",
  document: (id: string) => `/ventes/documents/${id}`,
  /** Vente rapide caveau (autre agent). */
  caveau: "/ventes/caveau",
  /** Paramètres facturation (autre agent). */
  parametres: "/ventes/parametres",
  /** Carnet des factures REÇUES des fournisseurs (FE-1). */
  facturesRecues: "/ventes/factures-recues",
  /** Diagnostic « Prêt pour la facture électronique » (FE-2). */
  factureElectronique: "/ventes/facture-electronique",
} as const;
